import React from "react";
import styled from "styled-components";

function TitleLogo({ width, height, isPopup = false, logo, ...props }) {
  return (
    <Container isPopup={isPopup} {...props}>
      <img
        src={logo}
        className='title-logo'
        alt='title logo'
        width={width}
        height={height}
      />
    </Container>
  );
}

export default TitleLogo;

const Container = styled.div`
  position: relative;

  .icon-winner__collect {
    position: absolute;
    bottom: -85px;
    left: 0;
    cursor: pointer;
    z-index: 3;
  }

  .icon-te__collection {
    position: absolute;
    left: -90px;
    z-index: 1;
    bottom: -190px;
    pointer-events: none;
  }

  .title-logo {
    display: block;
    margin: 0 auto;
    position: relative;
    z-index: 2;
    padding: 0 30px;
    margin-top: 10px;
    margin-bottom: 5px;
    max-width: 580px;
  }

  &.thadingyut-theme-logo {
    .title-logo {
      max-width: 100%;
      width: 80%;

      @media (max-width: 768px) {
        width: 100%;
      }
    }
  }

  .icon-sung__collection {
    position: absolute;
    right: -70px;
    z-index: 1;
    bottom: -173px;
    pointer-events: none;
  }

  @media (max-width: 768px) {
    .title-logo {
      width: 410px;
    }
  }

  @media (max-width: 576px) {
    .title-logo {
      margin-top: 35px;
    }

    .title-logo {
      width: 350px;
      max-width: 100%;
    }

    .icon-winner__collect {
      width: 74px;
    }

    .icon-te__collection {
      width: 192px;
      left: -60px;
      bottom: -85px;
    }

    .icon-sung__collection {
      right: -50px;
      width: 210px;
      bottom: -80px;
    }

    /* margin-bottom: ${(props) => (props.isPopup ? "0" : "70px")}; */
  }
`;
